import { render, staticRenderFns } from "./workerAreaForm.vue?vue&type=template&id=71b7bca6&scoped=true"
import script from "./workerAreaForm.vue?vue&type=script&lang=js"
export * from "./workerAreaForm.vue?vue&type=script&lang=js"
import style0 from "./workerAreaForm.vue?vue&type=style&index=0&id=71b7bca6&prod&scoped=true&lang=css"
import style1 from "./workerAreaForm.vue?vue&type=style&index=1&id=71b7bca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7bca6",
  null
  
)

export default component.exports